module.exports = __webpack_public_path__ + "img/5.b8adde81.jpg";